import { createSlice } from "@reduxjs/toolkit";

const initialState = null;

const device = createSlice({
  name: "device",
  initialState,
  reducers: {
    setDevice: (state, action) => {
      return { ...state, ...action.payload };
    },
    clearDevice: () => {
      return initialState;
    },
  },
});

// Export actions and reducer
export const { setDevice, clearDevice } = device.actions;
export default device.reducer;
